import { FinancialRecord, FishingTrip } from '../../types';
import { FinancialRecordSchema } from '@/schemas/financialSchema';
import { doc, deleteDoc, getDocs, collection } from 'firebase/firestore';
import { safeWrite } from './coreService';

export const fetchFinancialRecords = async (firestore: any): Promise<FinancialRecord[]> => {
  const snap = await getDocs(collection(firestore, 'financial_records'));
  return snap.docs.map(d => FinancialRecordSchema.parse(d.data()));
};

export const addFinancialRecord = async (firestore: any, record: FinancialRecord) => {
  await safeWrite(doc(firestore, 'financial_records', record.id), record);
};

export const updateFinancialRecord = async (firestore: any, record: FinancialRecord) => {
  await safeWrite(doc(firestore, 'financial_records', record.id), record);
};

export const removeFinancialRecord = async (firestore: any, id: string) => {
  await deleteDoc(doc(firestore, 'financial_records', id));
};

export const calculateFinancialStatement = (
  financialRecords: FinancialRecord[], 
  trips: FishingTrip[], 
  monthStr: string
) => {
  const records = financialRecords.filter(r => String(r.dueDate).startsWith(monthStr));
  const tripRecords: FinancialRecord[] = [];

  trips.forEach(t => {
     const arrival = typeof t.arrivalDate === 'string' 
        ? t.arrivalDate 
        : (t.arrivalDate as any)?.toString() || ''; 
     
     // Only consider trips arriving in the requested month
     if (arrival.startsWith(monthStr) && t.financials && t.financials.totalValue > 0) {
        
        // Find existing REAL records linked to this trip (any date)
        const linkedRecords = financialRecords.filter(r => r.tripId === t.id && r.type === 'income');
        const paidSoFar = linkedRecords.reduce((sum, r) => sum + r.amount, 0);
        
        const remaining = t.financials.totalValue - paidSoFar;

        // Only create a provisional record if there is remaining value
        if (remaining > 0) {
          tripRecords.push({
             id: `TRIP-PROV-${t.id}`, 
             type: 'income', 
             title: `Previsto: ${t.fishingCode} (${t.participants?.length || 0} pax)`,
             categoryId: 'pescaria',
             categoryName: 'Pescaria (Previsão)',
             amount: remaining, 
             totalAmount: remaining, 
             dueDate: t.arrivalDate as unknown as Date, 
             issueDate: new Date(), 
             paymentStatus: 'pending',
             status: 'pending',
             isRecurring: false, 
             createdAt: new Date(),
             updatedAt: new Date(),
             createdBy: 'system'
          } as any);
        }
     }
  });

  const allRecords = [...records, ...tripRecords];
  const summary = { totalIncome: 0, totalExpense: 0, balance: 0, pendingExpense: 0, dailyFlow: [] as any[] };
  
  allRecords.forEach(r => {
      if (r.type === 'income') summary.totalIncome += r.amount;
      if (r.type === 'expense') { 
          summary.totalExpense += r.amount; 
          if (r.paymentStatus === 'pending') summary.pendingExpense += r.amount;
      }
  });
  
  summary.balance = summary.totalIncome - summary.totalExpense;
  return { records: allRecords, summary };
};
